import { render } from "./VoucherGift.vue?vue&type=template&id=941ce800&scoped=true"
import script from "./VoucherGift.vue?vue&type=script&lang=js"
export * from "./VoucherGift.vue?vue&type=script&lang=js"

import "./VoucherGift.vue?vue&type=style&index=0&id=941ce800&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941ce800"]])

export default __exports__